import React, { useContext, useState } from 'react';

import { Container, Row, Col, Button } from 'react-bootstrap'
import { Header, Footer, SidebarOffcanvas, NavItems } from './../../shared/components/Panels'

import UserContext from './../../app/UserContext';
import { UserList } from './UserList'

/**
 * ユーザ一覧
 * @returns 
 */
const Users = () => {

  const { user, isLoaded } = useContext(UserContext);
  const [showSidebar, setShowSidebar] = useState(false);
  
  if (!isLoaded) return null;
  if (!user) return null;

  return (
    <>
      <Header onOpenSidebar={() => setShowSidebar(true)} />
      {/* モバイル: Offcanvas / デスクトップ: 固定カラム */}
      <SidebarOffcanvas show={showSidebar} onHide={() => setShowSidebar(false)} />

      <Container fluid className="p-0">
        <Row className="g-0">
          {/* 左 */}
          <Col lg={2} className="p-0 d-none d-lg-block sidebar-col">
            <NavItems />
          </Col>

          {/* 右 */}
          <Col lg={10} className="p-3 main-content">
            <UserList />
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  )
}

export default Users